export enum ApplicationPullingType {
  PRACTICE_PROGRAM = 'practice-program',
  CIVIC_SERVICE = 'civic-service',
}
